import { useState, useEffect } from 'react';
import { ProTable } from '@ant-design/pro-components';
import { Button, theme, App } from 'antd';
import {
    useGetThirdPartyCalculationInfoQuery,
    useGetThirdPartyBillingInvoiceNamesQuery,
    useGetAllCustomerUidQuery,
    useThirdPartyDetailCalculationBySelectMutation,
    useThirdPartyDetailCalculationBulkOperationBySearchMutation,
} from '../../../features/api/apiSlice';
import GenerateBillingBatchModal from './GenerateBillingBatchModal';
import { ThirdPartyCalculationColumns } from './ThirdPartyCalculationColumns';
import CalculationModal from './CalculationModal';
import SurchargeModal from './SurchargeModal';
import { useSelector } from 'react-redux';
function ThirdPartyCalculationPage() {
    const { token } = theme.useToken();
    const [searchData, setSearchData] = useState({});
    const { data, isLoading, isFetching, refetch } = useGetThirdPartyCalculationInfoQuery({ ...searchData });
    const { data: billingInvoiceNames } = useGetThirdPartyBillingInvoiceNamesQuery({ source_type: 1 }, { refetchOnMountOrArgChange: true });
    const { data: customerUidData } = useGetAllCustomerUidQuery();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [generateBillingBatchModalOpen, setGenerateBillingBatchModalOpen] = useState(false);
    const [generateBillingBatchModalTarget, setGenerateBillingBatchModalTarget] = useState('select');
    const [generateBillingBatchModalData, setGenerateBillingBatchModalData] = useState([]);
    const [surchargeModalContent, setSurchargeModalContent] = useState(null);
    const [surchargeModalOpen, setSurchargeModalOpen] = useState(false);
    const [calculationIsFilter, setCalculationIsFilter] = useState(false);
    const [calculationModalOpen, setCalculationModalOpen] = useState(false);
    const [calculationModalData, setCalculationModalData] = useState([]);
    const columns = ThirdPartyCalculationColumns(billingInvoiceNames, customerUidData, setSurchargeModalOpen, setSurchargeModalContent);
    const { notification } = App.useApp();
    const currUser = useSelector((state) => state.auth.user);
    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
            setSelectedRowKeys(selectedRowKeys);
            setSelectedRows(selectedRows);
        },
    };
    const [thirdPartyDetailCalculationBySelect, {
        isLoading: calculationBySelectLoading,
        isSuccess: calculationBySelectSuccess,
        isError: calculationBySelectError,
        error: calculationBySelectErrorMessage,
    }] = useThirdPartyDetailCalculationBySelectMutation();

    const [calculateThirdPartyDetailBySearch, {
        isLoading: calculationBySearchLoading,
        isSuccess: calculationBySearchSuccess,
        isError: calculationBySearchError,
        error: calculationBySearchErrorMessage,
    }] = useThirdPartyDetailCalculationBulkOperationBySearchMutation();

    useEffect(() => {
        if (calculationBySelectSuccess) {
            notification.success({
                message: '成功',
                description: '计算运费成功',
            });
            setCalculationModalOpen(false);
            setSelectedRowKeys([]);
            setSelectedRows([]);
        }
        if (calculationBySelectError) {
            notification.error({
                message: '错误',
                description: calculationBySelectErrorMessage,
            });
        }
    }, [calculationBySelectSuccess, calculationBySelectError, calculationBySelectErrorMessage]);

    useEffect(() => {
        if (calculationBySearchSuccess) {
            notification.success({
                message: '成功',
                description: '计算运费成功',
            });
            setCalculationModalOpen(false);
            setSelectedRowKeys([]);
            setSelectedRows([]);
        }
        if (calculationBySearchError) {
            notification.error({
                message: '错误',
                description: calculationBySearchErrorMessage,
            });
        }
    }, [calculationBySearchSuccess, calculationBySearchError, calculationBySearchErrorMessage]);


    const calculationBySelectButtonHandler = () => {
        const allSameStatus = selectedRows.every(row => row.status === '待计算' || row.status === '计费异常');
        if (!allSameStatus) {
            return notification.error({
                message: '错误',
                description: '请选择待计算或计费异常状态的数据，请检查后重试',
            });
        }
        const allSameUid = selectedRows.every(row => row.customer.uid === selectedRows[0].customer.uid);
        if (!allSameUid) {
            return notification.error({
                message: '错误',
                description: '请选择相同UID的数据，请检查后重试',
            });
        }
        setCalculationModalOpen(true);
        setCalculationIsFilter(false);
        setCalculationModalData(selectedRows);
    }

    const calculationBySearchButtonHandler = (searchConfig) => {
        searchConfig.form.validateFields().then((values) => {
            if (!values.status || (values.status !== '4' && values.status !== '5')) {
                return notification.error({
                    message: '错误',
                    description: '请于搜索栏选择待计算或计费异常状态后重试',
                });
            }
            if (!values.uid) {
                return notification.error({
                    message: '错误',
                    description: '请于搜索栏选择UID后重试',
                });
            }
            if (values.invoice) {
                return notification.error({
                    message: '错误',
                    description: '请清空搜索栏的出账批次后重试',
                });
            }
            setCalculationModalOpen(true);
            setCalculationIsFilter(true);
            setCalculationModalData(values);
        })
        
    }
    const generateBillingBatchBySelectButtonHandler = () => {
        // check if all selected rows have the same status 待出账
        const allSameStatus = selectedRows.every(row => row.status === '待出账');
        if (!allSameStatus) {
            return notification.error({
                message: '错误',
                description: '请选择待出账状态的数据，请检查后重试',
            });
        }
        const allSameUid = selectedRows.every(row => row.customer.uid === selectedRows[0].customer.uid);
        if (!allSameUid) {
            return notification.error({
                message: '错误',
                description: '请选择相同UID的数据，请检查后重试',
            });
        }
        setGenerateBillingBatchModalOpen(true);
        setGenerateBillingBatchModalTarget('select');
        setGenerateBillingBatchModalData(selectedRows);
    }
    const generateBillingBatchBySearchButtonHandler = (searchConfig, formProps) => {
        searchConfig.form.validateFields().then((values) => {
            if (!values.status || values.status !== '6') {
                return notification.error({
                    message: '错误',
                    description: '请于搜索栏选择待出账状态后重试',
                });
            }
            if (!values.uid) {
                return notification.error({
                    message: '错误',
                    description: '请于搜索栏选择UID后重试',
                });
            }
            if (values.invoice) {
                return notification.error({
                    message: '错误',
                    description: '请清空搜索栏的出账批次后重试',
                });
            }
            setGenerateBillingBatchModalOpen(true);
            setGenerateBillingBatchModalTarget('search');
            setGenerateBillingBatchModalData(values);
        })
    }

    const onCalculationModalSubmit = () => {
        if (calculationIsFilter) {
            const request = {
                ...calculationModalData,
                operation: 'calculation',
            }
            calculateThirdPartyDetailBySearch(request);
        } else {
            const formData = new FormData();
            formData.append('detail_ids', selectedRowKeys);
            thirdPartyDetailCalculationBySelect(formData);
        }
    }
    return (
        <>
            <ProTable
                search={{
                    labelWidth: 'auto',
                    defaultCollapsed: false,
                    collapseRender: false,
                    style: {
                        maxWidth: 'none',
                        background: token.colorFillAlter,
                        borderRadius: token.borderRadiusLG,
                        padding: 24,
                    },
                    submitterColSpanProps: {
                        span: 24,
                        style: {
                            display: 'flex',
                            justifyContent: 'space-between',
                        },
                    },
                    optionRender: (searchConfig, formProps, dom) => [
                        (currUser.button_permission?.includes('third_party_download_details') && <Button
                            key="generateBillingBatchButton"
                            type="primary"
                            onClick={() => generateBillingBatchBySearchButtonHandler(searchConfig, formProps)}
                            loading={false}
                        >
                            生成出账批次
                        </Button>),
                        (currUser.button_permission?.includes('third_party_generate_billing_batch') && <Button
                            key="calculationButton"
                            type="primary"
                            onClick={() => calculationBySearchButtonHandler(searchConfig, formProps)}
                            loading={false}
                        >
                            计算运费
                        </Button>),
                        ...dom,
                    ],
                }}
                request={(params, sort) => {
                    setSearchData({ ...params, sort });
                }}
                tableAlertOptionRender={() => {
                    return [
                        (currUser.button_permission?.includes('third_party_calculation') && <Button
                            key="calculation"
                            type="link"
                            onClick={() => {
                                calculationBySelectButtonHandler();
                            }}
                        >
                            计算运费
                        </Button>),
                        (currUser.button_permission?.includes('third_party_generate_billing_batch') && <Button
                            key="generateBillingBatch"
                            type="link"
                            onClick={() => {
                                generateBillingBatchBySelectButtonHandler();
                            }}
                        >
                            生成出账批次
                        </Button>),
                        <Button
                            key="unSelect"
                            type="link"
                            onClick={() => {
                                setSelectedRowKeys([]);
                            }}
                        >
                            取消选择
                        </Button>,
                    ];
                }}
                rowKey={record => record.id}
                manualRequest={true}
                dataSource={data?.results}
                loading={isLoading || isFetching}
                columns={columns}
                rowSelection={rowSelection}
                pagination={{
                    defaultPageSize: 10,
                    showSizeChanger: true,
                    pageSizeOptions: ['10', '20', '50', '100'],
                    total: data?.count,
                }}
                scroll={{ x: 'max-content' }}
                options={{
                    reload: () => refetch(),
                }}
            />
            <GenerateBillingBatchModal
                open={generateBillingBatchModalOpen}
                setOpen={setGenerateBillingBatchModalOpen}
                data={generateBillingBatchModalData}
                target={generateBillingBatchModalTarget}
                selectedRowKeys={selectedRowKeys}
                setSelectedRowKeys={setSelectedRowKeys}
                billingInvoiceNames={billingInvoiceNames}
                customerUidData={customerUidData}
                />
            <CalculationModal
                open={calculationModalOpen}
                setOpen={setCalculationModalOpen}
                loading={calculationBySelectLoading || calculationBySearchLoading}
                onSubmit={onCalculationModalSubmit}
                content={calculationModalData}
                isFilter={calculationIsFilter}
                customerUidData={customerUidData}
                billingInvoiceNames={billingInvoiceNames}
            />
            <SurchargeModal
                open={surchargeModalOpen}
                setOpen={setSurchargeModalOpen}
                data={surchargeModalContent}
            />
        </>
    )
}

export default ThirdPartyCalculationPage;